import Button from "@rio-cloud/rio-uikit/Button";
import Dialog from "@rio-cloud/rio-uikit/Dialog";
import { useIntl } from "react-intl";

export type ExportStage = "collect" | "writing" | "done" | "error";

const stageLabelId: Record<ExportStage, string> = {
  collect: "intl-msg:common.exportProgressKanbanDialog.stage.collect",
  writing: "intl-msg:common.exportProgressKanbanDialog.stage.writing",
  done: "intl-msg:common.exportProgressKanbanDialog.stage.done",
  error: "intl-msg:common.exportProgressKanbanDialog.stage.error",
};

interface ExportProgressKanbanDialogProps {
  show: boolean;
  stage: ExportStage;
  progress: number;
  detail?: string;
  onClose: () => void;
  errorMessage?: string;
}

export default function ExportProgressKanbanDialog({
  show,
  stage,
  progress,
  detail,
  onClose,
  errorMessage,
}: ExportProgressKanbanDialogProps) {
  const intl = useIntl();
  const stageLabel = intl.formatMessage({ id: stageLabelId[stage] });
  return (
    <Dialog
      show={show}
      title={intl.formatMessage({ id: "intl-msg:common.exportProgressKanbanDialog.title" })}
      subtitle={detail ? `${stageLabel} — ${detail}` : stageLabel}
      footer={
        <Button onClick={onClose} className="btn btn-primary" bsSize="lg">
          {intl.formatMessage({ id: "intl-msg:common.exportProgressKanbanDialog.close" })}
        </Button>
      }
      body={
        <div className="w-full mx-auto bg-white dark:bg-neutral-800 rounded-lg p-6">
          <div className="mb-2 text-size-14 text-color-black">{intl.formatMessage({ id: "intl-msg:common.exportProgressKanbanDialog.progress" })}</div>
          <div className="h-3 w-full rounded bg-gray-200 dark:bg-neutral-700 overflow-hidden">
            <div
              className="h-3 bg-[#27AE60]"
              style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}
            />
          </div>
          <div className="mt-2 text-right text-size-12 text-color-black">
            {Math.round(progress)}%
          </div>
          {stage === "error" && (
            <div className="mt-4 text-size-14 text-color-danger">
              {errorMessage || intl.formatMessage({ id: "intl-msg:common.exportProgressKanbanDialog.genericError" })}
            </div>
          )}
        </div>
      }
      onCloseValidation={() => {
        onClose();
        return true;
      }}
      className="dialog-export-progress"
      showCloseButton
    />
  );
}